import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchSaleMasterList = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    if(payload.store_list.length === 0) {
        return false
    } else {
        commit('resetSaleMasterOutstandingList')
        axios.post('/saleMaster/index.php', payload, accessTokenInfo.accessTokenInfo())
        .then(res => {
            if(res.data.try_again) {
                //dispatch('fetchInventoryInvoiceList', payload)
            } else {
                if(payload.show_outstanding) {
                    commit('setSaleMasterOutstandingList', res.data.response)
                    dispatch('fetchCustomerMasterData', {id: payload.customer_id})
                } else {
                    commit('setSaleMasterList', {response: res.data.response, total: res.data.total, page_number: res.data.page_number, page_number: res.data.page_number})
                }   
            }
        })
        .catch(error => {
            commit('displayMessageAlert', {message: error, type: 'Error'})
        })
        .finally( () => {
            commit('toggleLoadingState', false)
        })
    }
}

export const fetchTrialSchedule = ({commit}, payload) => {
    commit('toggleLoadingState', true)

    axios.post('/saleMaster/fetchTrialSchedule.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        commit('setTrialScheduleList', res.data.response)

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)    
    })
}

export const saveTrialSchedule = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)

    axios.post('/saleMaster/saveTrialSchedule.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        dispatch('fetchTrialSchedule', {sale_item_id: payload.sale_item_id})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)    
    })
}

export const submitShortcutSale = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)

    axios.post('/saleMaster/saveShortcut.php', payload.props, accessTokenInfo.accessTokenInfo())
    .then(res => {
        console.log(JSON.stringify(res.data))
        if(res.data.status) {
            commit('setSaleShortcutInfo', {
                id: res.data.id,
                sale_number_prefix: res.data.sale_number_prefix,
                sale_number: res.data.sale_number
            })

            if(payload.newSaleItemProps) {
                setTimeout(() => {
                    payload.newSaleItemProps.sale_id = res.data.id
                    dispatch('submitNewSaleItem', payload.newSaleItemProps)    
                }, 100);                
            }            
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)    
    })
}

export const removeTrialSchedule = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)

    axios.post('/saleMaster/removeTrialSchedule.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        dispatch('fetchTrialSchedule', {sale_item_id: payload.sale_item_id})

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)    
    })
}

export const fetchSaleMasterDataBalance = ({commit}, payload) => {
    commit('toggleLoadingState', true)

    axios.post('/saleMaster/fetchBalance.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        commit('setSaleMasterBalance', res.data.total_paid)
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)    
    })
}

export const fetchSaleMasterData = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)

    axios.post('/saleMaster/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        //console.log(JSON.stringify(res.data));
        //return
        if(res.data.status) {
            
            dispatch('fetchCustomerPaymentList', {
                store_list: [{store_id: 0}],
                sale_id: res.data.response.id
            })

            if(payload.notify_customer) {
                commit('setSaleMailTrigger', {master_url: payload.master_url, access_token: payload.access_token, id: res.data.response.id})
            } else if(payload.print_default_paper) {
                commit('setSalePrintWindow', {
                    sale_id: payload.id,
                    printTitle: payload.default_print_size === 0 ? 'Paper Size: A5' : 'Paper Size: 2 inch Thermal Paper',
                    pageSize: payload.default_print_size === 0 ? 'A5' : payload.default_print_size === 1 ? 'Thermal' : 'A4',
                    access_token: payload.access_token,
                    master_url: payload.master_url
                })
            }
            
            const customerPayload = {id: res.data.response.customer_id, navigate: false, saleSource: true}
            dispatch('fetchCustomerMasterData', customerPayload)
            if(payload.fabricPriceSlabExists) {
                dispatch('fetchCustomerMasterMeasurementData', customerPayload)
            } else {
                commit('unSetLoadingMeasurements')
            }
            
            if(res.data.response.paying_customer_id>0) {
                dispatch('fetchCustomerMasterAutocompleteList', {query: '', customer_code: 0, customer_id: res.data.response.paying_customer_id})
            }

            commit('setSaleMasterData', {response: res.data.response, copy: payload.copy})                       
                
            setTimeout(() => {
                commit('editRowCalculations')  
                
                setTimeout(() => {
                    if(payload.navigate) {
                        router.push(router.currentRoute.fullPath+'/form/')
                    }
                }, 300);                
            }, 500);
            
        } else {
            commit('resetSaleMasterData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)    
    })
}

export const submitSaleMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/saleMaster/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {      
        console.log(JSON.stringify(res.data))
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});            
            let printDefaultPaper = false
            if(res.data.default_print>=0) {
                printDefaultPaper = true;
            }

            dispatch('fetchSaleMasterData', 
                {
                    id: res.data.id, 
                    print_default_paper: printDefaultPaper, 
                    default_print_size: res.data.default_print,
                    master_url: payload.master_url,
                    access_token: payload.access_token,
                    notify_customer: payload.notify_customer,
                    fabricPriceSlabExists: payload.fabricPriceSlabExists
                })
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        //commit('toggleLoadingState', false)
    })
}

export const submitRetailDelivery = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleMaster/submitRetailDelivery.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {      
        
        if(res.data.status) {
            dispatch('fetchSaleMasterData', { id: res.data.id })
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        //commit('toggleLoadingState', false)
    })
}

export const sendCustomerOverDueReminder = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displaySuccessNotification', {message: 'Request submitted successfully!!!'});            
        commit('toggleLoadingState', false)
    }, 1000);
    
    axios.post('/customerMaster/sendBalanceOverDueReminder.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {      
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        
    })
}

export const sendSaleOverDueReminder = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displaySuccessNotification', {message: 'Request submitted successfully!!!'});            
        commit('toggleLoadingState', false)
    }, 1000);
    
    axios.post('/saleMaster/sendSaleOverDueReminder.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {      
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        
    })
}

export const deleteSaleMasterData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    
    /*setTimeout(() => {
        if(payload.navBack) {
            router.push('/salesorders', '')
        } else if(payload.popup) {
            //dispatch('fetchSaleMasterList', payload.list)
        } else {
            router.push('/salesorders', '')
            dispatch('fetchSaleMasterList', {nav: payload.nav, sale_type: payload.sale_type, store_list: payload.store_list})
        }
    }, 15000);*/

    axios.post('/saleMaster/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push('/salesorders', '')
            } else if(payload.popup) {
                //dispatch('fetchSaleMasterList', payload.list)
            } else {
                router.push('/salesorders', '')
                dispatch('fetchSaleMasterList', {nav: payload.nav, sale_type: payload.sale_type, store_list: payload.store_list})
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const loadSubCategoryItem = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/itemCategory/loadSubCategoryItem.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(!res.data.status) {
           commit('displayErrorNotification', {message: 'Empty result, no matching data!!!'});
        }
        //document.getElementById('item_search_field').focus()
        commit('setSubCategorySaleItemList', res.data.response)

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const redeemSalesDiscountCoupon = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/discountCoupon/redeemSalesDiscountCoupon.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('setRedeemSalesDiscountCoupon', res.data.response)
            setTimeout(() => {
                commit('editRowCalculations')
            }, 300);
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const cancelSalesOrder = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleMaster/cancelSalesOrder.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('displayMessageAlert', {displayHTML: true, message: "Cancelled the items successfully.", type: 'Success'})
            dispatch('fetchSaleMasterData', {id: res.data.id, navigate: false})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
       
    })
}

export const createSalesInvoice = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleMaster/createInvoice.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            dispatch('fetchSaleMasterData', {id: payload.order_id, navigate: false})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
       
    })
}

export const updateCustomerRef = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleMaster/updateCustomerRef.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            dispatch('fetchSaleMasterData', {id: payload.id, navigate: true})
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchExchangeRate = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleMaster/fetchExchangeRate.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(payload.source) {
            if(payload.source == 'po') {
                commit('setPOExchangeRate', res.data.response)
            } else if(payload.source == 'pi') {
                commit('setInventoryInvoiceExchangeRate', res.data.response)
            }
        } else {
            commit('setSalesExchangeRate', res.data.response)
        }
        
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const updateSalesDeliveryDate = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleMaster/updateSalesDeliveryDate.php', payload.data, accessTokenInfo.accessTokenInfo())
    .then(res => {
        dispatch('loadAppointmentList', {selected_date: payload.selected_date, store_id: payload.store_id})
        dispatch('fetchMonthlyAppointments', {selected_month: new Date(payload.selected_date).getMonth()+1, store_id: payload.store_id})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const updateSalesTrialDate = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleMaster/updateSalesTrialDate.php', payload.data, accessTokenInfo.accessTokenInfo())
    .then(res => {
        dispatch('loadAppointmentList', {selected_date: payload.selected_date, store_id: payload.store_id})
        dispatch('fetchMonthlyAppointments', {selected_month: new Date(payload.selected_date).getMonth()+1, store_id: payload.store_id})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchCostSheet = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleMaster/fetchCostSheet.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        commit('setSalesCostSheet', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchSalesOrderWIP = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/saleMaster/fetchSalesOrderWIP.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const emailSaleList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    setTimeout(() => {
        commit('displayMessageAlert', {message: 'Admin will receive an email in a few minutes.', type: 'Info'})
        commit('toggleLoadingState', false)
    }, 1000);
    axios.post('/saleMaster/emailSaleList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const saleDeliveryMarkingShortcut = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/saleMaster/saleDeliveryMarkingShortcut.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});            
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitNewSaleItem = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/saleMaster/submitNewSaleItem.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        console.log(JSON.stringify(res.data))
        payload.id = res.data.list_id
        payload.sl_no = res.data.sl_no
        payload.combination_item_list = res.data.combinationItemList

        commit('mutateSaleOrderItemStatus', payload)        
        //dispatch('fetchSaleMasterData', {id: payload.sale_id, navigate: false, fabricPriceSlabExists: payload.fabricPriceSlabExists})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const updateSalePromiseDateShortcut = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/saleMaster/updateSalePromiseDateShortcut.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        console.log('promise date updated')
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/saleMaster/actions.js